import PropTypes from 'prop-types';
import { Snackbar, SnackbarContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ToastMessage from './ToastMessage';
import { anchorToast } from './ToastOptions';

const useStyles = makeStyles({
  wrapper: {
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    flexDirection: 'column',
    alignItems: 'center'
  }
});

const Toast = ({ defaultMessage, Icon, backgroundColor, onDismissClick, serverResponseId }) => {
  const classes = useStyles({ backgroundColor });

  return (
    <Snackbar
      open
      anchorOrigin={anchorToast}
      autoHideDuration={6000}
      backgroundcolor={backgroundColor}
      onClose={onDismissClick}
    >
      <SnackbarContent
        className={classes.wrapper}
        message={<ToastMessage content={defaultMessage} Icon={Icon} errorId={serverResponseId} />}
      />
    </Snackbar>
  );
};

Toast.propTypes = {
  defaultMessage: PropTypes.string,
  Icon: PropTypes.any,
  backgroundColor: PropTypes.string,
  onDismissClick: PropTypes.func,
  serverResponseId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default Toast;
